import { User, UserManager, WebStorageStateStore } from 'oidc-client';
import axios, { AxiosRequestConfig } from 'axios';
import jwt_decode from 'jwt-decode';
import { createCustomerTokenProvider } from './customerAuthService';
import { getDiscoveryConfig } from '../client/configuration';


export const configureUserManager = (): UserManager | any => {
  const keys = localStorage.getItem('config');
  if(!keys) {
    setTimeout(() => {
      const IDENTITY = keys && JSON.parse(localStorage.getItem('config') || '').identityUrl;
      const AUTHCLIENT = keys && JSON.parse(localStorage.getItem('config') || '').authClientId;
      console.log('AUTHCLIENT w timeout', AUTHCLIENT);
      console.log('IDENTITY w timeout', IDENTITY);
    
      const config = {
        authority: IDENTITY,
        client_id: AUTHCLIENT,
        redirect_uri: `${window.location.origin}/callback`,
        post_logout_redirect_uri: window.location.origin,
        silent_redirect_uri: `${window.location.origin}/silentrenew`,
    
        response_type: 'id_token token',
        scope: 'openid profile l2care l2care.services',
    
        loadUserInfo: false,
        SaveTokens: true,
        RequireHttpsMetadata: true,
        GetClaimsFromUserInfoEndpoint: false,
    
        automaticSilentRenew: false
      };

      const METADATA_OIDC = {
        issuer: window.location.origin,
        jwks_uri: `${window.location.origin}/discovery/keys`,
        authorization_endpoint: window.location.origin,
        token_endpoint: `${window.location.origin}/oauth2/token`,
        userinfo_endpoint: `${window.location.origin}/userinfo`,
        end_session_endpoint: `${window.location.origin}/oauth2/logout`
      };
    
      const MEDATADA_URL = '/.well-known/openid-configuration';

      const userManager = new UserManager({
        ...config,
        userStore: new WebStorageStateStore({ store: window.localStorage }),
        metadata: {
          ...METADATA_OIDC,
        },
        metadataUrl: MEDATADA_URL,
      });
    
      userManager.events.addUserLoaded((user) => {
        if (window.location.href.indexOf('signin-oidc') !== -1) {
          navigateToScreen('/');
        }
      });
    
      userManager.events.addSilentRenewError((e) => { });
    
      userManager.events.addAccessTokenExpired(() => {
        signinRedirect(userManager);
      });
      return userManager;
    }, 1000);
  } else {
    const IDENTITY = JSON.parse(localStorage.getItem('config') || '').identityUrl;
    const AUTHCLIENT = keys && JSON.parse(localStorage.getItem('config') || '').authClientId;
    console.log('AUTHCLIENT', AUTHCLIENT);
    console.log('IDENTITY', IDENTITY);
  
    const config = {
      authority: IDENTITY,
      client_id: AUTHCLIENT,
      redirect_uri: `${window.location.origin}/callback`,
      post_logout_redirect_uri: window.location.origin,
      silent_redirect_uri: `${window.location.origin}/silentrenew`,
  
      response_type: 'id_token token',
      scope: 'openid profile l2care l2care.services',
  
      loadUserInfo: false,
      SaveTokens: true,
      RequireHttpsMetadata: true,
      GetClaimsFromUserInfoEndpoint: false,
  
      automaticSilentRenew: false
    };
  
    const userManager = new UserManager({
      ...config,
      userStore: new WebStorageStateStore({ store: window.localStorage }),
    });
  
    userManager.events.addUserLoaded((user) => {
      if (window.location.href.indexOf('signin-oidc') !== -1) {
        navigateToScreen('/');
      }
    });
  
    userManager.events.addSilentRenewError((e) => { });
  
    userManager.events.addAccessTokenExpired(() => {
      signinRedirect(userManager);
    });
    return userManager;
  }
};

export const signinSilent = (userManager: UserManager): void => {
  userManager.signinSilent();
};

export const isAuthenticated = (
  userManager?: UserManager
): boolean => {
  const config = localStorage.getItem('config');

  if (!config) {
    return false;
  }
  const IDENTITY = JSON.parse(config || '').identityUrl;
  const AUTHCLIENT = JSON.parse(config || '').authClientId;

  const customerTokenProvider = createCustomerTokenProvider();
  let user: string = '{}';

  let sessionUser = localStorage.getItem(
    `oidc.user:${IDENTITY}:${AUTHCLIENT}`
  );

  if (sessionUser) {
    user = sessionUser;
    const oidcStorage = JSON.parse(user);
    if (!!oidcStorage && !!oidcStorage.access_token) {
      userManager && setupAxiosInterceptor(userManager);
      return true;
    }
  }
  return false;
};


export const getDiscoveryKeys = async (): Promise<any> => {
  const storedKeys = localStorage.getItem('keys');
  const config = localStorage.getItem('config');
  const IDENTITY = config && JSON.parse(config || '').identityUrl;
  if (!storedKeys) {
    getDiscoveryConfig().then(async () => {
      const keys = await (await axios.get(`${IDENTITY}/.well-known/openid-configuration/jwks`)).data.keys;
      localStorage.setItem('keys', JSON.stringify(keys));
      return keys;
    }).catch(function (err) {
      console.log(err);
    });
  }

};

export const navigateToScreen = (path: string): void => {
  window.location.replace(path);
};

export const signinSilentCallback = (userManager: UserManager): void => {
  console.log('==== ================== ================== signinsilent', userManager);
  userManager.signinSilentCallback().then(function (user) {
    console.log('======================================================================== user', user);
  }).catch(function (err) {
    console.log(err);
  });
};

export const signinRedirect = (userManager?: UserManager): void => {
  if(!userManager) {
    const getUserManager = configureUserManager();
    getDiscoveryKeys().then((keys) => {
      getUserManager.settings.signingKeys = keys;
      getUserManager.signinRedirect();
    });
  } else {
      getDiscoveryKeys().then((keys) => {
        userManager.settings.signingKeys = keys;
        userManager.signinRedirect();
      });
  }
};

export const signinRedirectCallback = async (userManager: UserManager): Promise<void> => {
  if(!userManager) {
    const getUserManager: UserManager = configureUserManager();
    getUserManager.settings.signingKeys = JSON.parse(
      localStorage.getItem('keys') ?? '{}'
    );
    getUserManager.signinRedirectCallback().then(function (user) {
      window.location.href = '/dashboard';
      console.log('======================================================================== user', user);
    }).catch(function (err) {
      console.log(err);
    });
  } else {
    userManager.settings.signingKeys = JSON.parse(
      localStorage.getItem('keys') ?? '{}'
    );
    userManager.signinRedirectCallback().then(function (user) {
      window.location.href = '/dashboard';
      console.log('======================================================================== user', user);
    }).catch(function (err) {
      console.log(err);
    });
  }
};

export const signoutRedirectCallback = (userManager: UserManager): void => {
  userManager.signoutRedirectCallback();
  userManager.clearStaleState();
};

export const logout = async (userManager?: UserManager): Promise<void> => {
  if (userManager) {
    let user = await userManager.getUser();
    userManager.signoutRedirect({
      id_token_hint: user?.id_token
    });
    userManager.removeUser();
    userManager.signoutRedirectCallback();
  }
  localStorage.clear();
};

export const getUserData = async (
  userManager: UserManager
): Promise<string> => {
  try {
    if (isAuthenticated(userManager)) {
      const user = await getUser(userManager);
      let role = user.profile['l2care.role'];
      const displayName = user.profile.name;
      const email = user.profile.email;
      const sessionExpires = user.expires_at;
      return JSON.stringify({ role, displayName, email, sessionExpires });
    } else {
      return JSON.stringify({ role: 'none', displayName: '', email: '', sessionExpires: '' });
    }
  } catch (error) {
    return JSON.stringify({ role: 'none', displayName: '', email: '', sessionExpires: '' });
  }
};

const getUser = async (userManager: UserManager): Promise<User> => {
  const user: User | null = await userManager.getUser();
  if (!user) {
    return await userManager.signinRedirectCallback();
  }
  return user;
};

export const getIdToken = async (userManager: UserManager): Promise<string> => {
  const token: string = (await getUser(userManager)).access_token;
  return token;
};

export const decodeToken = async (userManager: UserManager) => {
  const idToken = await getIdToken(userManager);
  return jwt_decode(idToken);
};


export const setupAxiosInterceptor = async (
  userManager: UserManager,
  customerManager?: string
) => {
  axios.interceptors.request.use(async (config: AxiosRequestConfig) => {
    const access_Token = await getIdToken(userManager);
    config.headers.Authorization = `Bearer ${access_Token}`;
    axios.defaults.headers.common.Authorization = `Bearer ${access_Token}`;
    return config;
  });

  axios.interceptors.response.use(
    (response) => {
      return response;
    },
    async function (error) {
      const originalRequest = error.config;
      if ((error.response.status === 403 || error.response.status === 401) && !originalRequest._retry) {
        originalRequest._retry = true;
        const access_token = await getIdToken(userManager);
        axios.defaults.headers.common.Authorization = `Bearer ${access_token}`;
        return axios(originalRequest);
      }
      return Promise.reject(error);
    }
  );
};
